import React, { useState } from 'react';
import { Flex, Typography, Box, Button, InlineLink } from '@fullstory/components';
import css from './index.module.scss';
import { classNames } from '@fullstory/util/fmt';
import { PlanContactSidecar, ContactPaneId, ReasonId } from '@fullstory/overlays-ui';
import { FormattedMessage } from 'react-intl';

interface FeaturePromotionProps {
  headerText: string;
  bodyText: string;
  className: 'dataExports' | 'conversions' | 'journeys';
}

export const FeaturePromotion: React.FunctionComponent<FeaturePromotionProps> = props => {
  const [sidecarOpen, setSidecarOpen] = useState(false);
  return (
    <Flex
      testId="feature-promotion"
      column
      className={classNames(css.exportEmptyState, css[props.className])}
    >
      <Box className={css.art} marginTop={64} />
      <Box marginTop={48} marginBottom={16}>
        <Typography variant="heading1" textAlign="center">
          {props.headerText}
        </Typography>
      </Box>
      <Box marginBottom={16} width={550}>
        <Typography variant="body1" textAlign="center">
          {props.bodyText}
        </Typography>
      </Box>
      <Box paddingTop={16} marginBottom={24}>
        <Button
          size="large"
          variant="fill-primary"
          onClick={() => setSidecarOpen(true)}
          justifyContent="center"
          className={css.cta}
        >
          <FormattedMessage defaultMessage="Let’s talk" id="dBOBbC" />
        </Button>
      </Box>
      <Box marginBottom={64}>
        <Typography variant="body2">
          <FormattedMessage
            defaultMessage="Or, <a>compare plans.</a>"
            id="R3vyI8"
            values={{
              a(chunks) {
                return (
                  <InlineLink href="https://fullstory.com/pricing" newTab>
                    {chunks}
                  </InlineLink>
                );
              },
            }}
          />
        </Typography>
      </Box>
      <PlanContactSidecar
        initialReasonId={ReasonId.AccountChange}
        initialPane={ContactPaneId.ContactUs}
        closeFn={() => setSidecarOpen(false)}
        open={sidecarOpen}
      />
    </Flex>
  );
};
